/**
 * Formatação de tempo de jornada.
 *
 * Tudo em MINUTOS inteiros, nunca em horas com decimal: 8,5h contra 510min é a
 * diferença entre acumular erro de ponto flutuante ao somar 220 dias e não
 * acumular.
 */

/** 510 vira "8h30". Negativo mantém o sinal, porque saldo negativo existe. */
export function horas(minutos: number | null | undefined): string {
  if (minutos === null || minutos === undefined) return "sem registro";
  const neg = minutos < 0;
  const m = Math.abs(minutos);
  const h = Math.floor(m / 60);
  const r = m % 60;
  return `${neg ? "-" : ""}${h}h${r > 0 ? String(r).padStart(2, "0") : ""}`;
}

/** Com dois pontos, para coluna que alinha: "8:30", "-1:15". */
export function relogio(minutos: number | null | undefined): string {
  if (minutos === null || minutos === undefined) return "";
  const neg = minutos < 0;
  const m = Math.abs(minutos);
  return `${neg ? "-" : ""}${Math.floor(m / 60)}:${String(m % 60).padStart(2, "0")}`;
}

/** "2026-08-23T08:02:00" vira "08:02". */
export const hora = (iso: string): string => iso.slice(11, 16);

export const diaDaSemana = (iso: string): string =>
  ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"][
    new Date(`${iso.slice(0, 10)}T12:00:00Z`).getUTCDay()] ?? "";

/** Fim de semana ganha tratamento visual próprio no espelho. */
export const ehFimDeSemana = (iso: string): boolean => {
  const d = new Date(`${iso.slice(0, 10)}T12:00:00Z`).getUTCDay();
  return d === 0 || d === 6;
};

export function primeiroEUltimoDoMes(competencia: string): { de: string; ate: string } {
  const [a, m] = competencia.split("-").map(Number) as [number, number];
  const ultimo = new Date(Date.UTC(a, m, 0)).getUTCDate();
  return { de: `${competencia}-01`, ate: `${competencia}-${String(ultimo).padStart(2, "0")}` };
}
